export let WarningModalName;

(function (WarningModalName) {
  WarningModalName["CONVERSION_WARNING"] = "conversion_warning";
  WarningModalName["TRANSACTION_ERROR"] = "transaction_error";
})(WarningModalName || (WarningModalName = {}));